import BibleChapter from './BibleChapter';
import Testament from './Testament';

export default class BibleBook {

    private chapters = new Map<number, BibleChapter>();

    constructor(private readonly index: number, private readonly name: string,
        private readonly shortName: string, private readonly testament: Testament) {
    }

    public getIndex(): number {
        return this.index;
    }

    public getName(): string {
        return this.name;
    }

    public getShortName(): string {
        return this.shortName;
    }

    public getTestament(): Testament {
        return this.testament;
    }

    public getChapterCount(): number {
        return this.chapters.size;
    }

    public getChapters(): BibleChapter[] {
        return Array.from(this.chapters.values());
    }

    public getChapter(chapterNumber: number): BibleChapter {
        const chapter = this.chapters.get(chapterNumber);
        if (chapter === undefined) {
            throw new Error('Chapter not found');
        }
        return chapter;
    }

    public getOrSetChapter(index: number, chapterNumber: number, name: string, shortName: string): BibleChapter {
        let chapter = this.chapters.get(chapterNumber);
        if (chapter === undefined) {
            chapter = new BibleChapter(index, chapterNumber, name, shortName, this);
            this.chapters.set(chapterNumber, chapter);
        }
        return chapter;
    }
}
